import { PveCampEntry, TierLabel } from "../types/pve";
import { formatDuration, formatNumber, secondsUntil } from "../lib/format";
import { CurrencyValue } from "./CurrencyIcon";
import { TierShield } from "./TierShield";
import { UnitClassIcons } from "./icons";
import { GiPerson } from "react-icons/gi";

interface Props {
  camps: PveCampEntry[];
  now: Date;
  onPick: (c: PveCampEntry) => void;
  onBack: () => void;
}

export function PveCampList({ camps, now, onPick, onBack }: Props) {
  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center gap-2 px-3 py-2">
        <button
          type="button"
          onClick={onBack}
          className="rounded-lg bg-tg-secondaryBg px-3 py-1.5 text-sm"
        >
          ←
        </button>
        <div className="font-medium">Логова монстров</div>
      </div>

      <div className="flex-1 space-y-2 overflow-y-auto px-3 pb-3">
        {camps.map((c) => {
          const tier = TierLabel[c.tier] ?? TierLabel[1];
          const cooldownLeft = c.nextAttackAt ? secondsUntil(c.nextAttackAt, now) : 0;
          const disabled = c.onCooldown && cooldownLeft > 0;
          return (
            <button
              key={c.id}
              type="button"
              disabled={disabled}
              onClick={() => onPick(c)}
              className="flex w-full items-center gap-3 rounded-xl bg-tg-secondaryBg p-3 text-left disabled:opacity-50"
            >
              <TierShield tier={c.tier} size={48} className="shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <div className="truncate font-medium">{c.name}</div>
                  <div className={`rounded bg-tg-bg px-1.5 py-0.5 text-xs ${tier.color}`}>
                    {tier.name}
                  </div>
                </div>
                <div className="mt-0.5 line-clamp-1 text-xs text-tg-hint">
                  {c.description}
                </div>
                <div className="mt-1 flex flex-wrap items-center gap-1.5 text-xs text-tg-hint">
                  {c.garrison.slice(0, 3).map((s) => {
                    const Icon = UnitClassIcons[s.unitClass] ?? GiPerson;
                    return (
                      <span key={s.unitId} className="inline-flex items-center gap-0.5">
                        <Icon size={12} />
                        {formatNumber(s.count)}
                      </span>
                    );
                  })}
                  <span>·</span>
                  <CurrencyValue kind="gold" value={formatNumber(c.loot.gold)} />
                  <CurrencyValue kind="xp" value={formatNumber(c.heroXp)} />
                </div>
                {disabled && (
                  <div className="mt-1 text-xs text-tg-accent">
                    {formatDuration(cooldownLeft)} до следующей атаки
                  </div>
                )}
              </div>
              <div className="text-tg-hint">›</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
